module.exports = __webpack_public_path__ + "static/media/blue-delete.8b5854b5.svg";